<div (click)="preventGridSelection()">
  <a *ngIf="value" [href]="'mailto:' + value" target="_blank">{{ value }}</a>
  <span *ngIf="!value">{{ value | replaceEmpty }}</span>
</div>
